import { Flex } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/tag";
import { useMemo } from "react";
import { UnidadeComPessoaResponse } from "core/features/unidades/typings/unidade";
import { formatPhone } from "infra/helpers/number";

function usePessoasEUnidadesColumns() {
  return useMemo(() => {
    return [
      {
        title: "Unidade",
        width: "150px",
        render: (original: UnidadeComPessoaResponse) => (
          <div>
            {original.numero}
            {original.blocoQuadra ? (
              <>
                {" "}
                -{" "}
                <Tag variant="outline" colorScheme="blue">
                  Bloco/Quadra: {original.blocoQuadra}
                </Tag>
              </>
            ) : null}
          </div>
        ),
      },
      {
        title: "Nome",
        dataIndex: "nomePessoa",
        render: (nome: string) => {
          return <Flex>{nome}</Flex>;
        },
      },
      {
        title: "Celular",
        width: "200px",
        dataIndex: "celular",
        render: (celular: string) => {
          return <Flex>{celular ? formatPhone(celular) : "--"}</Flex>;
        },
      },
    ];
  }, []);
}

export default usePessoasEUnidadesColumns;
